import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Coerce anything that might be an error (string, Error, Meta Graph API error
 * object, nested { error: ... } envelope) into a readable one-liner for the UI.
 * Avoids the "[object Object]" bug when the backend hands back a structured
 * error instead of a string.
 */
export function errorMessage(e: unknown, fallback = 'something went wrong'): string {
  if (!e) return fallback;
  if (typeof e === 'string') return e;
  if (e instanceof Error) return e.message || fallback;
  if (typeof e === 'object') {
    const obj = e as Record<string, unknown>;
    // Unwrap one level of { error: ... } (Meta / Supabase edge envelopes)
    if (obj.error && obj.error !== e) return errorMessage(obj.error, fallback);
    const message = typeof obj.message === 'string' ? obj.message : null;
    const type = typeof obj.type === 'string' ? ` (${obj.type})` : '';
    const code = obj.code != null ? ` [${String(obj.code)}]` : '';
    if (message) return `${message}${type}${code}`;
    try { return JSON.stringify(e).slice(0, 300); } catch { return fallback; }
  }
  return String(e);
}
